// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IUploadImageRequest,
  TUploadImageModel,
  IMappers,
  TUploadImageResponse,
  TUploadImageResponse_1,
  TUploadImageResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TUploadImageModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'promotions-flow-control',
  pathApi: '/v1/upload-image/',
  requestType: 'formData',
  interserviceAuthEnabled: true,
} as TUploadImageModel;

export function createUploadImageModel(parameters: IUploadImageRequest): TUploadImageModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IUploadImageOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IUploadImageRequest;
}

export async function fetchUploadImage<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IUploadImageOptions<TResponse200, TResponse400>): Promise<TUploadImageResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createUploadImageModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TUploadImageResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TUploadImageResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TUploadImageResponse;
}
